import {UIGameKnightController} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGameKnightController'
import {UIGamePlayerInformationKnightView} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGamePlayerInformationKnightView'
import {UIMGamePlayerInformationKnightView} from './UIMGamePlayerInformationKnightView'
import {MechanicValidatorKnightPlayer} from '@colonist/game-mechanic-validators'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGameMechanic} from '../../../../shared/scripts/ui_game/UIGameEventController'
import {GameStateEnums} from '../../../../../../code/shared/GameEnums'
import {PlayerColor, MechanicPirateState, MechanicRobberState, MechanicKnightState} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

/**
 * @deprecated Will be removed once Pixi.js Mobile Player Information view is removed. Please use UIGameKnightController directly.
 */
export class UIMGameKnightController extends UIGameKnightController implements UIGameMechanic {
    private playerInformationKnightIconViews: UIGamePlayerInformationKnightView[]

    constructor(uiGameManager: UIGameManager, knightState: MechanicKnightState, robberState: MechanicRobberState | undefined, pirateState: MechanicPirateState | undefined) {
        super(uiGameManager, knightState, robberState, pirateState)
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        this.playerInformationKnightIconViews = []
        this.initPlayerInformationKnightIconViews()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.KnightStateUpdated: this.highlightPlayerWithHighestKnightStrength(); break
            case UIGameEventEnums.CanvasResized: this.initPlayerInformationKnightIconViews(); break
            default: break
        }
    }

    private initPlayerInformationKnightIconViews() {
        this.playerInformationKnightIconViews.forEach((view) => view.destroy())
        this.playerInformationKnightIconViews = []

        for(const knightPlayerValidator of this.knightValidator.getKnightPlayerValidators()) {
            const newKnightIconView = this.createPlayerInformationKnightView(knightPlayerValidator)
            this.playerInformationKnightIconViews.push(newKnightIconView)
        }

        this.highlightPlayerWithHighestKnightStrength()
    }

    private getPlayerInformationKnightIconView(player: PlayerColor): UIGamePlayerInformationKnightView | undefined {
        for(const playerInformationKnightIconView of this.playerInformationKnightIconViews) {
            if(playerInformationKnightIconView.knightPlayerValidator.playerColor === player) return playerInformationKnightIconView
        }
        return undefined
    }

    protected createPlayerInformationKnightView(knightPlayerValidator: MechanicValidatorKnightPlayer): UIGamePlayerInformationKnightView {
        return new UIMGamePlayerInformationKnightView(this.uiGameManager, knightPlayerValidator)
    }

    private highlightPlayerWithHighestKnightStrength() {
        const playersWithHighestKnightStrength = this.knightValidator.getPlayersWithHighestKnightStrength()
        const doesEveryPlayerHaveZeroKnightStrength = this.knightValidator.getTotalKnightStrength() === 0
        for(const playerColor of this.uiGameManager.gameController.getPlayerColors()) {
            const playerInformationKnightIconView = this.getPlayerInformationKnightIconView(playerColor)
            if(playerInformationKnightIconView == undefined) continue

            if(doesEveryPlayerHaveZeroKnightStrength) {
                playerInformationKnightIconView.highlight(false)
                continue
            }

            const doesPlayerHaveHighestKnightStrength = playersWithHighestKnightStrength.includes(playerColor)
            playerInformationKnightIconView.highlight(doesPlayerHaveHighestKnightStrength)
        }
    }
}
